import script from "./AboutUs.vue?vue&type=script&setup=true&name=AboutUs&lang=js"
export * from "./AboutUs.vue?vue&type=script&setup=true&name=AboutUs&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=48768978&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48768978"]])

export default __exports__